export default {
  header: 'Špecifikácia auditu',
  specificationName: 'Názov špecifikácie',
};
